/**
 * @generated SignedSource<<d6f60c58acb7306b48a7873107d01516>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterOperator = "BEGINS_WITH" | "CONTAINS" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "NEQ" | "NOT_CONTAINS" | "%future added value";
export type OrderByDirection = "ASC" | "DESC" | "%future added value";
export type DrawingSetVersionTableInput = {
  filter?: DrawingSetVersionTableFilter | null | undefined;
  limit: number;
  orderBy?: DrawingSetVersionTableOrder | null | undefined;
  page: number;
};
export type DrawingSetVersionTableFilter = {
  drawingSetId?: Filter | null | undefined;
  versionDate?: Filter | null | undefined;
};
export type Filter = {
  operator: FilterOperator;
  value: string;
};
export type DrawingSetVersionTableOrder = {
  versionDate?: OrderByDirection | null | undefined;
};
export type getDrawingSetVersionTableQuery$variables = {
  input: DrawingSetVersionTableInput;
};
export type getDrawingSetVersionTableQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"drawingSetVersionTableFragment">;
};
export type getDrawingSetVersionTableQuery = {
  response: getDrawingSetVersionTableQuery$data;
  variables: getDrawingSetVersionTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getDrawingSetVersionTableQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "drawingSetVersionTableFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getDrawingSetVersionTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetVersionTableConnection",
        "kind": "LinkedField",
        "name": "drawingSetVersionTable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DrawingSetVersionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DrawingSetVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdById",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "versionDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "drawingSetId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageTableInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "limit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "page",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "input"
        ],
        "handle": "connection",
        "key": "drawingSetVersionTableFragment___drawingSetVersionTable",
        "kind": "LinkedHandle",
        "name": "drawingSetVersionTable"
      }
    ]
  },
  "params": {
    "cacheID": "cb11cf8b7e53a07d3254fe17f69ba253",
    "id": null,
    "metadata": {},
    "name": "getDrawingSetVersionTableQuery",
    "operationKind": "query",
    "text": "query getDrawingSetVersionTableQuery(\n  $input: DrawingSetVersionTableInput!\n) {\n  ...drawingSetVersionTableFragment_2VV6jB\n}\n\nfragment drawingSetVersionFragment on DrawingSetVersion {\n  id\n  createdAt\n  updatedAt\n  createdById\n  fileName\n  versionDate\n  status\n  drawingSetId\n  jobId\n}\n\nfragment drawingSetVersionTableConnectionFragment on DrawingSetVersionTableConnection {\n  edges {\n    cursor\n    node {\n      ...drawingSetVersionFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageTableInfoFragment\n  }\n}\n\nfragment drawingSetVersionTableFragment_2VV6jB on Query {\n  drawingSetVersionTable(input: $input) {\n    edges {\n      cursor\n      node {\n        ...drawingSetVersionFragment\n        id\n        __typename\n      }\n    }\n    ...drawingSetVersionTableConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageTableInfoFragment on PageTableInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n  totalCount\n  limit\n  page\n  totalPages\n}\n"
  }
};
})();

(node as any).hash = "4a990737010caded4ce755e182240a7b";

export default node;
